import { mapActions } from "vuex";

export default {
  data() {
    return {
      currentDeleteFilterPreset: null,
      filterPresetName: "",
    };
  },
  methods: {
    ...mapActions(["getFilterPresets", "createFilterPreset", "editFilterPreset", "deleteFilterPreset"]),
    loadFilterPresets(list, cb, errorCb) {
      const p = {
        type: list,
      };
      this.getFilterPresets({ params: p, customLoading: true })
        .then((res) => {
          if (cb) {
            cb(res);
          }
        })
        .catch(() => {
          if (errorCb) errorCb();
        });
    },
    selectFilterPreset(preset) {
      this.filters.forEach((filter, key) => {
        if (filter.switch) {
          if (Object.prototype.hasOwnProperty.call(preset.value, filter.switch.name)) {
            this.$set(this.filters[key].switch, "model", preset.value[filter.switch.name]);
            this.$set(this.filters[key], "active", true);
          } else {
            this.$set(this.filters[key].switch, "model", true);
            this.$set(this.filters[key], "active", false);
          }
        }
        if (
          filter.select &&
          !filter.select.custom &&
          !Object.prototype.hasOwnProperty.call(preset.value, filter.select.name)
        ) {
          if (filter.select.preselectModel) this.$set(this.filters[key].select, "model", filter.select.preselectModel);
        }
        if (
          filter.select &&
          !filter.select.custom &&
          !filter.select.isCondition &&
          Object.prototype.hasOwnProperty.call(preset.value, filter.select.name)
        ) {
          if (Object.prototype.hasOwnProperty.call(preset.value, filter.select.name)) {
            if (filter.filterGroup) this.$set(this.groups[filter.filterGroup], "active", true);
            this.$set(
              this.filters[key].select,
              "model",
              this.transformValuesToModel(preset.value[filter.select.name], filter.select.name)
            );
            this.$set(this.filters[key], "active", true);
          } else {
            if (filter.filterGroup) this.$set(this.groups[filter.filterGroup], "active", false);
            this.$set(this.filters[key].select, "model", false);
            this.$set(this.filters[key], "active", false);
          }
        }
        if (filter.select && filter.select.custom && !filter.select.isCondition) {
          if (filter.select.name.split("_").slice(0, 2).join("_") === "with_custom" && preset.value.with_custom) {
            this.$set(
              this.filters[key].select,
              "model",
              this.transformValuesToModel(preset.value.with_custom, filter.select.name)
            );
            this.$set(this.filters[key], "active", filter.select.model.length > 0);
          }
          if (filter.select.name.split("_").slice(0, 2).join("_") === "without_custom" && preset.value.without_custom) {
            this.$set(
              this.filters[key].select,
              "model",
              this.transformValuesToModel(preset.value.without_custom, filter.select.name)
            );
            this.$set(this.filters[key], "active", filter.select.model.length > 0);
          }
        }
        if (filter.dateTimeRange) {
          let model = [];
          filter.dateTimeRange.name.forEach((field) => {
            if (preset.value[field]) {
              model.push(new Date(preset.value[field]));
              this.$set(this.filters[key], "active", true);
            }
          });
          this.$set(this.filters[key].dateTimeRange, "model", model);
        }
        if (filter.select && filter.isCondition) {
          filter.isCondition.name.forEach((condition) => {
            if (Object.prototype.hasOwnProperty.call(preset.value, condition)) {
              this.$set(this.filters[key].select, "model", this.transformValuesToModel("custom", filter.select.name));
            }
          });
        }
      });
    },
    transformValuesToModel(values, select) {
      let res = [];
      if (select === "with_template" || select === "without_template") {
        values.forEach((value) => {
          this.templates.forEach((template) => {
            if (template.uid === value) {
              res.push({ label: template.name, value: template.uid });
            }
          });
        });
      }
      if (select === "with_user" || select === "without_user") {
        values.forEach((value) => {
          this.users.forEach((user) => {
            if (user.uid === value) {
              res.push({
                label: user.first_name + " " + user.last_name,
                value: user.uid,
              });
            }
          });
        });
      }
      if (select === "with_contact" || select === "without_contact") {
        values.forEach((value) => {
          this.contacts.forEach((contact) => {
            if (contact.uid === value) {
              res.push({
                label: contact.first_name + " " + contact.last_name,
                value: contact.uid,
              });
            }
          });
        });
      }
      if (select === "with_status" || select === "without_status") {
        values.forEach((value) => {
          let title = "";
          switch (value) {
            case "ARCHIVED":
              title = this.$t("stati.status.title");
              break;
            case "POSTED":
              title = this.$t("stati.sent.title");
              break;
            case "VISITED":
              title = this.$t("stati.views.title");
              break;
            case "UPLOADS":
              title = this.$t("stati.uploads.title");
              break;
            case "DOWNLOADS":
              title = this.$t("stati.downloads.title");
              break;
            default:
              title = this.projectsStati[value].title[this.teams[this.$route.params.team].account.locale]
                ? this.projectsStati[value].title[this.teams[this.$route.params.team].account.locale]
                : this.projectsStati[value].title.default;
          }
          res.push({ label: title, value: value });
        });
      }
      if (select === "with_tag" || select === "without_tag") {
        values.forEach((value) => {
          this.teamTags.forEach((tag) => {
            if (tag.name === value) {
              res.push({ label: tag.name, value: tag.name });
            }
          });
        });
      }
      if (select === "with_locale" || select === "without_locale") {
        values.forEach((value) => {
          this.teamLanguages.forEach((lang) => {
            if (lang === value) {
              res.push({ label: this.$t('lang["' + lang + '"]'), value: lang });
            }
          });
        });
      }
      if (select === "time_col") {
        return values.length > 0 ? { label: this.$t("filters." + values), value: values } : null;
      }
      if (select === "time_relative") {
        return values.length > 0 ? { label: this.$t("filters.timeRelative." + values), value: values } : null;
      }
      if (
        select.split("_").slice(0, 2).join("_") === "with_custom" ||
        select.split("_").slice(0, 2).join("_") === "without_custom"
      ) {
        if (this.projectsCustomFields) {
          Object.keys(this.projectsCustomFields).forEach((key) => {
            if (this.projectsCustomFields[key].filterable && key === select.split("_").slice(2).join("_")) {
              values.forEach((value) => {
                const val = value.split(".");
                const k = val[0];
                const v = val[1];
                if (k === key) {
                  let label;
                  this.projectsCustomFields[key].config.options.forEach((option) => {
                    option.label[this.teams[this.$route.params.team].account.locale]
                      ? (label = option.label[this.teams[this.$route.params.team].account.locale])
                      : (label = option.label.default);
                    if (option.value === parseInt(v)) {
                      res.push({ label, v });
                    }
                  });
                }
              });
            }
          });
        }
      }
      return res;
    },
    transformFilterToPresetFormat(filters = []) {
      const dataValue = {};
      filters.forEach((filter) => {
        if (filter.active) {
          if (filter.switch) dataValue[filter.switch.name] = filter.switch.model;
          if (filter.select && !filter.select.custom && filter.select.multiple) {
            filter.select.model.forEach((select) => {
              if (!dataValue[filter.select.name]) dataValue[filter.select.name] = [];
              dataValue[filter.select.name].push(select.value);
            });
          } else if (filter.select && !filter.select.custom && !filter.select.multiple) {
            dataValue[filter.select.name] = filter.select.model.value;
          } else if (filter.select && filter.select.custom) {
            const filterName = filter.select.name.split("_").slice(0, 2).join("_");
            const customFieldName = filter.select.name.split("_").slice(2).join("_");
            if (!dataValue[filterName]) dataValue[filterName] = [];
            filter.select.model.forEach((select) => {
              dataValue[filterName].push(customFieldName + "." + select.value);
            });
          }
          if (filter.dateTimeRange) {
            if (
              filter.dateTimeRange.model.length === 2 &&
              filter.dateTimeRange.model[0] !== "" &&
              filter.dateTimeRange.model[1] !== ""
            ) {
              dataValue["time_from"] = this.$moment(filter.dateTimeRange.model[0])
                .tz(this.teams[this.$route.params.team].account.timezone)
                .format();
              dataValue["time_to"] = this.$moment(filter.dateTimeRange.model[1])
                .tz(this.teams[this.$route.params.team].account.timezone)
                .format();
            } else {
              dataValue["time_from"] = "";
              dataValue["time_to"] = "";
            }
          }
        }
      });
      return dataValue;
    },
    resetFilters() {
      this.filters.forEach((filter, key) => {
        if (filter.switch) {
          this.$set(this.filters[key], "active", false);
          this.$set(this.filters[key], "checkbox", true);
          this.$set(this.filters[key].switch, "model", true);
        }
        if (filter.select) {
          this.$set(this.filters[key], "active", false);
          this.$set(this.filters[key].select, "model", []);
        }
        if (filter.dateTimeRange) {
          this.$set(this.filters[key], "active", false);
          this.$set(this.filters[key].dateTimeRange, "model", []);
        }
      });
      Object.keys(this.groups).forEach((key) => {
        this.$set(this.groups[key], "active", false);
      });
    },
    saveFilterPreset(filters, list, filtername, edit = false, cb, errorCb) {
      const vm = this;
      const data = {
        customLoading: true,
        name: filtername,
        type: list,
        value: vm.transformFilterToPresetFormat(filters),
      };
      if (!edit) {
        vm.createFilterPreset(data)
          .then((res) => {
            vm.loadFilterPresets(list, cb(res));
            vm.$snotify.success(vm.$t("toasts.createFilterPreset.success"), vm.$t("toasts.success"), {
              icon: vm.$successIcon,
            });
          })
          .catch(() => {
            if (errorCb) errorCb();
            vm.$snotify.error(vm.$t("toasts.createFilterPreset.error"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          });
      } else {
        vm.editFilterPreset({
          customLoading: true,
          params: {
            filterPreset: vm.inboxNavi.currentPreset.uid,
          },
          data,
        })
          .then(() => {
            vm.loadFilterPresets(list, cb);
            vm.$snotify.success(vm.$t("toasts.createFilterPreset.success"), vm.$t("toasts.success"), {
              icon: vm.$successIcon,
            });
          })
          .catch(() => {
            if (errorCb) errorCb();
            vm.$modal.hide("saveFilterPreset");
            vm.$snotify.error(vm.$t("toasts.createFilterPreset.error"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          });
      }
    },
    deletePreset(preset, list, cb = false) {
      const vm = this;
      vm.deleteFilterPreset({ filterPreset: preset })
        .then(() => {
          vm.loadFilterPresets(list, cb);
          vm.$snotify.success(vm.$t("toasts.deleteFilterPreset.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });
        })
        .catch(() => {
          vm.$snotify.error(vm.$t("toasts.deleteFilterPreset.error"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
        });
    },
  },
};
